import React from 'react';

import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { genURL, genURLTEST } from '../../../../_getjson';
export default function SelectStkJobOrderFG(props) {

    const {
        multiselect
    } = props


    const [state, setState] = React.useState({
        loading: true,
        data: [],
        selectionModel: [],
        openDialog: false,
        responseData: [],
        titleDialog: "เลือกรายการ",
        sendData: false
    })

    // const rows = [
    //     { id: 1, code: 'Hello', name: 'World' },
    //     { id: 2, code: 'DataGridPro', name: 'is Awesome' },
    //     { id: 3, code: 'MUI', name: 'is Amazing' },
    // ];

    React.useEffect(() => {
        getData();
        return () => {
        }
    }, [])


    React.useEffect(() => {
        if (state.sendData === true) {
            props.resultData(state.responseData)
        }

        return () => {
        }
    }, [state.responseData])

    const getData = async () => {
        await setState((prevState) => ({
            ...prevState,
            loading: true
        }))
        //  let url = genURLTEST(`GetCSSTKJobOrderFGData?`)
        let url = genURL(`csfg/GetCSSTKJobOrderFGData?`)
        console.log(url);
        let res = await axios.get(url).then(val => {
            console.log(val.data)
            return val.data
        })

        console.log("res", res);
        if (res !== null) {
            await setState((prevState) => ({
                ...prevState,
                data: res,
                loading: false
            }))
        } else {
            await setState((prevState) => ({
                ...prevState,
                loading: false
            }))
        }
        //   await setData(rows)
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 90, hide: true }, {
            field: 'DOCNO',
            headerName: 'ใบสั่งผลิต',
            width: 200,
            editable: false,
            flex: 0
        }, {
            field: 'STARTDATE',
            headerName: 'วันที่เริ่มต้น',
            width: 200,
            editable: false,
            flex: 0
        }, {
            field: 'FINISHDATE',
            headerName: 'กำหนดเสร็จ',
            width: 150,
            editable: false,
            flex: 0
        }, {
            field: 'SHIPDATE',
            headerName: 'นัดส่งมอบ',
            width: 250,
            editable: false,
            flex: 0
        }, {
            field: 'FGCODE',
            headerName: 'รหัสสินค้า',
            width: 250,
            editable: false,
            flex: 0
        }, {
            field: 'FGNAME',
            headerName: 'ชื่อสินค้า',
            width: 250,
            editable: false,
            flex: 0
        }, {
            field: 'UNITNAME',
            headerName: 'หน่วย',
            width: 250,
            editable: false,
            flex: 0
        }, {
            field: 'UNITCODE',
            headerName: 'UNITCODE',
            width: 250,
            editable: false,
            flex: 0,
            hide: true
        }, {
            field: 'FGQTY',
            headerName: 'สั่งผลิต',
            width: 250,
            editable: false,
            flex: 0
        }, {
            field: 'QUANTITY',
            headerName: 'ค้างรับ',
            width: 250,
            editable: false,
            flex: 0
        }, {
            field: 'ARCODE',
            headerName: 'ARCODE',
            width: 250,
            editable: false,
            flex: 0
        }, {
            field: 'ARNAME',
            headerName: 'ลูกค้า',
            width: 250,
            editable: false,
            flex: 0
        }
    ];

    const handleDoubleClick = async (e) => {
        // console.log(selectionModel); 
        // f
        let result = []
        if (state.selectionModel.length > 0) {
            result = await state.data.filter((elem) => {
                return state.selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            await result.push(e.row)
        }
        await setState((prevState) => ({
            ...prevState,
            responseData: result,
            sendData: true
        }
        ))
    }

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                }}
            >
                <GridToolbarQuickFilter />
            </Box>
        );
    }
    const resultSubData = (e) => {
        // console.log(e)
        setState((prevState) => ({
            ...prevState,
            openDialog: false
        }))
        props.resultData(e)
    }
    const closeDialogs = (e) => {
        //  console.log(e);
        setState((prevState) => ({
            ...prevState,
            openDialog: false
        }))
    }
    return (
        <>
            <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                {state.loading === true ? "กำลังโหลด..." :
                    state.data.length > 0 ? <DataGrid
                        rows={state.data}
                        columns={columns}

                        sx={{
                            fontFamily: "Customfont !important"
                        }}
                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            // filter: {
                            //     filterModel: {
                            //         items: [],
                            //         quickFilterValues: ['quick', 'filter'],
                            //     },
                            // },
                        }}
                        pageSizeOptions={[10]}
                        checkboxSelection={multiselect}
                        disableSelectionOnClick
                        onSelectionModelChange={(newSelectionModel) => {
                            setState((prevState) => ({
                                ...prevState,
                                selectionModel: newSelectionModel
                            }))
                        }}
                        selectionModel={state.selectionModel}
                        onRowDoubleClick={e => handleDoubleClick(e)}
                        //onRowClick={e => handleClick(e)}
                        components={{ Toolbar: QuickSearchToolbar }}
                    /> : "ไม่พบข้อมูล"}
            </Box>
        </>
    )

}
SelectStkJobOrderFG.propTypes = { multiselect: PropTypes.bool, }
SelectStkJobOrderFG.defaultProps = {
    multiselect: false
};